import React from 'react';
import StorefrontPage from '../../components/core/StorefrontPage';
import { StorefrontOrderStatusContainer } from './containers/storefront-order-status.container';

/**
 * StorefrontOrderStatusShellPage — public storefront order-status shell.
 * Wires StorefrontOrderStatusContainer into the /shop/order/:uuid OpenRoute.
 *
 * No authentication required (OpenRoute).
 */
const StorefrontOrderStatusShellPage: React.FC = () => {
    return (
        <StorefrontPage>
            <StorefrontOrderStatusContainer />
        </StorefrontPage>
    );
};

export default StorefrontOrderStatusShellPage;
